
import React, { createContext, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuthProvider } from './useAuthProvider';
import type { AuthContextType } from './types';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuthProvider();

  useEffect(() => {
    console.log('AuthProvider initializing...');
    
    // Set up auth state listener
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, currentSession) => {
        console.log('Auth state changed:', event);
        
        if (currentSession?.user) {
          console.log('User is authenticated:', currentSession.user.id);
          // Use setTimeout to avoid Supabase auth deadlock
          setTimeout(() => {
            console.log('Fetching profile for user:', currentSession.user?.id);
            // The profile fetching is handled in useAuthProvider
          }, 0);
        } else {
          console.log('No authenticated user');
        }
      }
    );

    // Check for existing session immediately
    const initializeAuth = async () => {
      try {
        const { data: { session: currentSession } } = await supabase.auth.getSession();
        console.log('Existing session check:', currentSession ? 'Session found' : 'No session');
      } catch (error) {
        console.error('Error checking session:', error);
      }
    };

    initializeAuth();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  // Provide complete auth context with all required methods
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};
